<!-- 盘点审批 -->
<template>
    <div class="app-container" >
      <el-scrollbar v-loading="fullscreenLoading" ref="scrollbarRef" :height="scrollbar_height"  @scroll="handleScroll">
        <el-row :gutter="8" class="mt10">
            <el-col :span="4" v-if="warehouseList.length>1">
                <el-select
                    v-model="formData.warehouse"
                    filterable
                    clearable
                    placeholder="请选择仓库名称"
                >
                    <el-option
                        v-for="subItem in warehouseList"
                        :key="subItem.warehouseId"
                        :label="subItem.warehouseName"
                        :value="subItem.warehouseId"
                    />
                </el-select>
            </el-col>
            <el-col :span="4" >
                <el-select
                    v-model="formData.checkInventoryRecordType"
                    filterable
                    clearable
                    placeholder="请选择盘点类型"
                >
                    <el-option
                        v-for="subItem in getDictListByParentCode('checkInventoryRecordType')"
                        :key="subItem.libraryCode"
                        :label="subItem.libraryName"
                        :value="subItem.libraryCode"
                    />
                </el-select>
            </el-col>
            <el-col :span="4" >
                <el-button type="primary" icon="Search" @click="handleQuery">搜索</el-button>
                <el-button icon="Refresh" @click="resetQuery">重置</el-button>
            </el-col>
        </el-row>
        <el-row :gutter="8" class="checkInventoryCard">
        <el-col :span="8"  v-for="item in tableData" :key="item.checkInventoryRecordId">
            <el-card class="cardContainer" :class="item.checkInventoryRecordType" @click="toDetail(item)" style="min-width: 500px;" shadow="hover">
                <template #header>
                    <div class="checkHeader">
                        <div class="checkName">
                            <svg-icon class-name="checkInventory" icon-class="checkInventory"/> {{ item.checkInventoryRecordName }}
                        </div>
                        <div :class="item.approvalStatus == '0' ? 'checkStatus' : 'checkStatusEnd'" class="showBtn">
                            {{statusFilter(item.approvalStatus) }}
                        </div>
                        <div class="btnClass"><el-button type="primary"  :disabled=" item.approvalStatus == '1'"  @click.stop="handleCheckEnd(item)">提交审批结果</el-button></div>
                    </div>
                    
                </template>
                <div class="OutInInventory checkTitle mt10"> {{ item.warehouseName }}</div>
                <el-row class="OutInInventory mt5">
                    <el-col :span="16"><span>库存总量：</span>{{ item.inventoryTotal }}</el-col>
                    <el-col :span="8"><span>入库总量：</span> {{ item.inInventoryTotal }}</el-col>
                    <!-- <el-col :span="12"><span>所属仓库：</span> {{ item.warehouseName }}</el-col> -->
                </el-row>
                <el-row class="OutInInventory">
                    <el-col :span="16"><span>开始时间：</span>{{ item.startTime }}</el-col>
                    <el-col :span="8"><span>出库总量：</span>{{ item.outInventoryTotal }}</el-col>
                </el-row>
                <el-row class="OutInInventory">
                    <el-col :span="16"><span>结束时间：</span>{{ item.endTime }}</el-col>
                </el-row>
                <!-- <div class="OutInInventory">
                    <span>状态：</span>
                </div> -->
            </el-card>
        </el-col>
      </el-row>
      </el-scrollbar>
    </div>
  </template>
  
  <script setup>
  import Table from "@/components/Element/Table";
  import {  ref,onMounted,reactive,watch } from "vue";
  import { getCustomTableCols } from "@/tableColumn";
  import {
    selectCheckInventoryApprovalRecord,
    checkInventoryApprovalEnd,
    selectMainApprovalError,
    selectOtherApprovalError,
    } from "@/api/checkInventory";
    
  import { useRouter } from "vue-router";
  import { listWarehouse } from "@/api/warehouse/warehouse";
  import useCacheStore from "@/store/modules/cache";
  import { errorMsg,succesMsg } from "@/utils/msgBox";
  import useInventoryStore from "@/store/modules/inventory";
  const inventoryStore = useInventoryStore();
  const cacheStore = useCacheStore();
  const { getWarehouseNameById,getDictListByParentCode } = cacheStore;
  const warehouseList = cacheStore.warehouse;
  const router = useRouter();
  
  /**仅支持 Vue 3.3+  配置name 为了是 keep-alive :include 生效 */
//   defineOptions({
//     name: "checkInventoryRecord",
//   });
  const state = reactive({
    loading: false,
    _scrollTop: 0, 
 })
  const scrollbar_height = ref('calc(100vh - 150px)')
  const tableData = ref([]);
  const loading = ref(false);
  const fullscreenLoading = ref(false);
  const searchOptions = ref()
  const pageIndex = ref(1);
  const pageSize = ref(15)
  const formData = ref({})
  const tableDataDialogEnd = ref([]);
  const totalDialog = ref(0);
  const loadingDialog = ref(false);
  const searchMethod = ()=>{
    listWarehouse().then(resData => {
      searchOptions.value = resData.data
      // curTotal.value = resData.pageParam.totleInfo
    }).finally(() => {
      // searchLoading.value = false
    })
  }
  const scrollbarRef = ref(null)
  const handleScroll = ({  scrollTop })=>{
    let wrapRef = scrollbarRef.value.wrapRef
    scrollbarRef.value.moveY = wrapRef.scrollTop * 100 / wrapRef.clientHeight
    scrollbarRef.value.moveX = wrapRef.scrollLeft * 100 / wrapRef.clientWidth
    let poor = wrapRef.scrollHeight - wrapRef.clientHeight
    if (scrollTop + 2 >= poor) {
        state._scrollTop = scrollTop
        pageIndex.value ++
        // emits("loadData", true)
        handleSearch()
    }
  }
onMounted(()=>{
    searchMethod()
    handleSearch()
})
watch(
  () => inventoryStore.approvalInventoryStatus,
    (newVal) => {
      if(newVal === '1'){
        tableData.value = [];
        pageIndex.value = 1;
        pageSize.value = 15;
        handleSearch()
      }
    }
)
const statusFilter=(val)=>{
    switch (val) {
        case '0':
            return '待审批'
            break;
        default:
            return '已审批'
            break;
    }
}
  const handleSearch = () => {
    sessionStorage.setItem('approvalStatus','')
    let whereSql = null
    if(Object.keys(formData.value).length>0){
        let arr = []
        for (let key in formData.value){
            let obj= {
                column:key,
                querLogic:'like',
                value:formData.value[key]
            }
            arr.push(obj)
        }
        whereSql = JSON.stringify(arr)
    }
    fullscreenLoading.value = true;
    selectCheckInventoryApprovalRecord({pageIndex:pageIndex.value,pageSize:pageSize.value,whereSql:whereSql})
      .then((res) => {
        // let arr = []
        res.data?.forEach(item =>{
            item.warehouseName = getWarehouseNameById(item.warehouse)
        })
        tableData.value =tableData.value.concat(res.data) ;
        // total.value = res?.pageParam?.totleInfo ? res.pageParam.totleInfo : 0;
      })
      .catch(() => {})
      .finally(() => {
        fullscreenLoading.value = false;
      });
  };
  const resetQuery = ()=>{
    pageIndex.value = 1;
    pageSize.value = 9;
    formData.value = {};
    tableData.value = [];
    handleSearch()
  }
  const handleQuery = ()=>{
    pageIndex.value = 1;
    pageSize.value = 9;
    tableData.value = [];
    handleSearch()
  }
  const dialogOpenEnd = ref(false)
const toDetail=(item)=>{
    router.push({path:"/checkInventory/checkInventoryMenu",query:{data:JSON.stringify(item),type:'approval'}});
}
const addEqptDialogOpen = ref()
const checkInventoryRecordId = ref('')
const handleCheckEnd = async(val) =>{
    checkInventoryRecordId.value = val.checkInventoryRecordId
    const otherRes = await selectOtherApprovalError({checkInventoryRecordId:val.checkInventoryRecordId})
   if(otherRes.data.length>0){
      errorMsg('辅材或耗材异常数据，请前往详情处理')
   }else{
       const mainRes = await selectMainApprovalError({checkInventoryRecordId:val.checkInventoryRecordId})
       if(mainRes.data.length>0){
        errorMsg('主材存在异常数据，请前往详情处理')
       }else{
            const approvalRes = await checkInventoryApprovalEnd({checkInventoryRecordId:val.checkInventoryRecordId})
            if(approvalRes.status == 1){
                succesMsg('审批完成')
            }else{
                errorMsg('审批失败')
            }
       }
   }
 }
  </script>
  
  <style lang="scss" scoped>
    .checkInventoryCard{
        display: flex;
        flex-wrap: wrap;
        .checkHeader{
            display:flex;
            justify-content:space-between;
            font-weight:bold;
            &:hover{
                .showBtn{
                    opacity:0;
                }
                .btnClass{
                    display:block
                }
            }
            .checkStatus{
                color:#ed064b;
            }
            .checkStatusEnd{
                color:#8f8a8b;
            }
            .showBtn{
                opacity:1;
            }
            .btnClass{
                display:none;
                position:absolute;
                right:8px;
                top:4px;
            }
        }
        .cardContainer{
            margin: 20px;
            :deep(.el-card__header) {
                padding: 2px 10px;
                position:relative;
                cursor:pointer;
                // background-color: #eff7f9;
            }
            :deep(.el-card__body) {
                cursor: pointer;
            }
            .checkTitle{
                font-weight:bolder;
                text-align:center;
                color:#555 !important;
            }
            span{
                font-weight:bolder;
            }
            .OutInInventory{
                padding:10px 0;
                color:#717171
            }
        }
        .quarter{
            :deep(.el-card__header) {
                // padding: 2px 10px;
                background-color: #eff7f9;
            }
        }
        .month{
            :deep(.el-card__header) {
                // padding: 2px 10px;
                background-color: #d2daf5;
            }
        }
        .custom{
            :deep(.el-card__header) {
                // padding: 2px 10px;
                background-color: #fff8c8;
            }
        }
        .year{
            :deep(.el-card__header) {
                // padding: 2px 10px;
                background-color: #efe5e8;
            }
        }
    }
  </style>
  